/* ============
 * Check-Userinfo Mixin
 * ============
 *
 * Make sure userinfo is available before route enter
 */
import store from '@/app/store'

export default {
  beforeRouteEnter (to, from, next) {
    if (!store.state.account.id) {
      store.dispatch('account/find').then(() => {
        next()
      })
        .catch(err => console.log(err))
    } else {
      next()
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/mixins/check-userinfo.js